﻿/* PDP â€” gallery + variant picker */
(function () {
  function initGallery(root) {
    const track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    const dots = root.querySelectorAll('[data-gallery-dots] [data-dot]');
    const prev = root.querySelector('[data-gallery-prev]');
    const next = root.querySelector('[data-gallery-next]');

    function active() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function go(idx) {
      track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' });
    }
    track.addEventListener('scroll', () => {
      const idx = active();
      dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    if (prev) prev.addEventListener('click', () => go(Math.max(0, active() - 1)));
    if (next) next.addEventListener('click', () => go(active() + 1));
  }

  function initVariantPicker(form, root) {
    const variantsEl = root.querySelector('[data-product-json]');
    if (!variantsEl) return;
    let variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    const variantInput = form.querySelector('[data-variant-id]');
    const variantSelect = form.querySelector('[data-variant-select]');
    const priceWrap = root.querySelector('[data-price]');
    const atc = form.querySelector('[data-add-to-cart]');
    const atcText = form.querySelector('[data-atc-text]');
    const bisTrigger = form.querySelector('[data-bis-trigger]');
    const buyRow = form.querySelector('[data-buy-row]');

    // When the variant is sold out, swap the qty/add-to-cart row for the
    // Klaviyo "Notify me" button (and vice-versa).
    function setBisVisible(visible) {
      if (bisTrigger) bisTrigger.hidden = !visible;
      if (buyRow) buyRow.hidden = visible;
    }

    function selectedOptions() {
      if (variantSelect) {
        const variant = variants.find((v) => String(v.id) === String(variantSelect.value));
        return variant ? variant.options : [];
      }
      const inputs = form.querySelectorAll('input[name^="options["]:checked');
      return Array.from(inputs).map((i) => i.value);
    }
    function findVariant(opts) {
      if (!opts.length && variantInput) {
        return variants.find((v) => String(v.id) === String(variantInput.value)) || variants[0] || null;
      }
      return variants.find((v) => v.options.every((o, i) => o === opts[i])) || null;
    }
    function updateLabels() {
      // For each option group, update the selected value display + active states
      const groups = form.querySelectorAll('[name^="options["]');
      const seen = new Set();
      groups.forEach((input) => {
        const groupName = input.name;
        if (seen.has(groupName)) return;
        seen.add(groupName);
        // Active class on parent label
        form.querySelectorAll(`[name="${groupName}"]`).forEach((i) => {
          const label = i.closest('label');
          if (label) label.classList.toggle('is-active', i.checked);
        });
      });
    }
    function update() {
      const opts = selectedOptions();
      const variant = findVariant(opts);
      updateLabels();

      if (!variant) {
        atc.disabled = true;
        atcText.textContent = 'Unavailable';
        setBisVisible(false);
        return;
      }
      variantInput.value = variant.id;
      if (variantSelect && String(variantSelect.value) !== String(variant.id)) {
        variantSelect.value = variant.id;
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      // Update price — use the Liquid-formatted strings so the currency
      // always matches the active market (set via Shopify `money` filter).
      if (priceWrap) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceWrap.innerHTML = `<span class="pdp__price-sale">${variant.price_formatted}</span><span class="pdp__price-compare">${variant.compare_at_price_formatted}</span>`;
        } else {
          priceWrap.innerHTML = `<span class="pdp__price-regular">${variant.price_formatted}</span>`;
        }
      }

      if (variant.available) {
        atc.disabled = false;
        atc.classList.remove('is-sold-out');
        atcText.textContent = atcText.dataset.preorderLabel || atc.dataset.preorderLabel || 'Add to cart';
        setBisVisible(false);
      } else {
        atc.disabled = true;
        atc.classList.add('is-sold-out');
        atcText.textContent = 'Sold out';
        setBisVisible(true);
      }

      /* Notifica el cambio de variante para que otros componentes reaccionen
         (p. ej. el stock badge low stock / last unit). */
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
    }

    form.addEventListener('change', (e) => {
      if (e.target.matches('input[name^="options["], [data-variant-select]')) update();
    });
    updateLabels();
    update();
  }

  function initMobileBuySticky(root) {
    const buy = root.querySelector('[data-buy-section]');
    if (!buy || buy.dataset.stickyBound === 'true') return;

    buy.dataset.stickyBound = 'true';

    const mobileMax = 749;
    let spacer = root.querySelector('[data-buy-spacer]');

    if (!spacer) {
      spacer = document.createElement('div');
      spacer.className = 'pdp__buy-spacer';
      spacer.setAttribute('data-buy-spacer', 'true');
      root.appendChild(spacer);
    }

    let rafId = null;

    function isMobile() {
      return window.innerWidth <= mobileMax;
    }

    function updateViewportOffset() {
      let bottomOffset = 0;

      if (window.visualViewport) {
        bottomOffset = Math.max(
          0,
          Math.round(window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop)
        );
      }

      buy.style.setProperty('--pdp-mobile-viewport-offset', `${bottomOffset}px`);
    }

    function syncSpacer() {
      if (!isMobile()) {
        spacer.style.height = '0px';
        return;
      }

      spacer.style.height = `${Math.ceil(buy.getBoundingClientRect().height)}px`;
    }

    function tick() {
      rafId = null;

      if (!isMobile()) {
        buy.style.removeProperty('--pdp-mobile-viewport-offset');
        buy.classList.remove('is-sticky-active');
        spacer.style.height = '0px';
        return;
      }

      updateViewportOffset();
      buy.classList.add('is-sticky-active');
      syncSpacer();
    }

    function schedule() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(tick);
    }

    schedule();

    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule);
    window.addEventListener('load', schedule);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', schedule);
      window.visualViewport.addEventListener('scroll', schedule);
    }

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(buy);
    }
  }

  function initAccordionLinks(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById(btn.dataset.accordionTrigger);
        if (target && target.tagName === 'DETAILS') {
          target.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initKiwiSizeChart(root) {
    const chart = root.querySelector('#kiwi-size-chart, .pdp__kiwi-size-chart');
    const host = root.querySelector('[data-kiwi-size-host]');
    const fallbackTrigger = host ? host.querySelector('[data-kiwi-size-trigger]') : null;

    function findOpener() {
      const scopes = [chart, root, document].filter(Boolean);
      for (const scope of scopes) {
        const candidates = scope.querySelectorAll('a, button, [role="button"], [class*="kiwi"], [class*="Kiwi"], [id*="kiwi"], [id*="Kiwi"], [class*="ks-"], [id*="ks-"]');
        for (const el of candidates) {
          if (el === fallbackTrigger) continue;
          const text = (el.textContent || '').trim().toLowerCase();
          const marker = `${el.className || ''} ${el.id || ''}`.toLowerCase();
          if (text.includes('size chart') || text.includes('size guide') || text.includes('guía') || marker.includes('kiwi') || marker.includes('ks-')) {
            return el;
          }
        }
      }
      return null;
    }

    function prepareOpener(opener) {
      opener.textContent = 'Guía de tallas';
      opener.classList.add('pdp__kiwi-opener-source');
      opener.setAttribute('data-kiwi-opener-source', 'true');
    }

    function mountOpener() {
      const opener = findOpener();
      if (!opener || !host) return;
      prepareOpener(opener);
      if (chart) chart.classList.add('pdp__kiwi-size-chart--ready');
    }

    if (fallbackTrigger && !fallbackTrigger.dataset.kiwiTriggerBound) {
      fallbackTrigger.dataset.kiwiTriggerBound = 'true';
      fallbackTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        mountOpener();
        const opener = findOpener();
        if (opener && opener !== fallbackTrigger) opener.click();
      });
    }

    if (chart && !chart.dataset.kiwiObserverBound) {
      chart.dataset.kiwiObserverBound = 'true';
      mountOpener();
      const localize = () => mountOpener();
      const observer = new MutationObserver(localize);
      observer.observe(chart, { childList: true, subtree: true, characterData: true });
      setTimeout(mountOpener, 500);
      setTimeout(mountOpener, 1500);
    }
  }

  function init() {
    const sections = document.querySelectorAll('.pdp');
    sections.forEach((root) => {
      initGallery(root);
      const form = root.querySelector('[data-pdp-form]');
      if (form) initVariantPicker(form, root);
      initMobileBuySticky(root);
      initAccordionLinks(root);
      initKiwiSizeChart(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
